import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { QueryCsvComponent } from './query-csv.component';

@NgModule({
  declarations: [QueryCsvComponent],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [QueryCsvComponent]
})
export class QueryCsvModule {}